// extracted by mini-css-extract-plugin
export default {"cardTitle":"style_cardTitle__ddLur","cabecalho":"style_cabecalho__msUrY","separador":"style_separador__8itN7"};